"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceKey = exports.reducer = exports.commonDataProviderActions = exports.initialState = void 0;
const flow_1 = __importDefault(require("lodash/fp/flow"));
const flatMap_1 = __importDefault(require("lodash/fp/flatMap"));
const mapValues_1 = __importDefault(require("lodash/fp/mapValues"));
const identity_1 = __importDefault(require("lodash/fp/identity"));
const keyBy_1 = __importDefault(require("lodash/fp/keyBy"));
const keyBy_2 = __importDefault(require("lodash/keyBy"));
const mapValues_2 = __importDefault(require("lodash/mapValues"));
const slices_1 = require("../../utils/@reduxjs/slices");
const toolkit_1 = require("../../utils/@reduxjs/toolkit");
const ConfigProvider_1 = require("../ConfigProvider");
const utils_1 = require("./utils");
const toStore_1 = require("./data/toStore");
const REDUCER_KEY = 'commonDataProvider';
// The initial state of the CommonDataProvider container
exports.initialState = (0, slices_1.getPreloadedState)(REDUCER_KEY, {
    entries: {
        sports: {},
        sportsIdsOrder: [],
        sportIdsByGenericSportId: {},
        outcomeCategories: {},
        markets: {},
        outcomeTypes: {},
        mainOutcomeTypes: {},
        currencies: {},
        marketCategories: { entries: {}, sortedIds: [] },
        categoryMarketInfosMap: {},
        virtualCategories: { entries: {}, sortedIds: [] },
        virtualMarketInfosMap: {},
        marketGroups: { entries: {}, sortedIds: [] },
        entityTags: {},
        systemCurrencies: {},
        matchPhases: {},
        hotProbabilitiesGroups: {},
        vCategoriesInfo: {
            entries: {},
            sortedIds: [],
        },
        vMarketsInfo: {},
        vMarketIdsByMarket: {},
    },
    fetchItems: {
        loading: false,
        error: null,
        refreshLoading: false,
        loaded: false,
    },
});
const commonDataProviderSlice = (0, toolkit_1.createSlice)({
    name: REDUCER_KEY,
    initialState: exports.initialState,
    reducers: {
        // eslint-disable-next-line unused-imports/no-unused-vars
        fetchCommonData(state, action) {
            state.entries = {
                sports: {},
                sportsIdsOrder: [],
                sportIdsByGenericSportId: {},
                outcomeCategories: {},
                markets: {},
                outcomeTypes: {},
                mainOutcomeTypes: {},
                currencies: {},
                marketCategories: { entries: {}, sortedIds: [] },
                categoryMarketInfosMap: {},
                virtualCategories: { entries: {}, sortedIds: [] },
                virtualMarketInfosMap: {},
                marketGroups: { entries: {}, sortedIds: [] },
                entityTags: {},
                systemCurrencies: {},
                matchPhases: {},
                hotProbabilitiesGroups: {},
                vCategoriesInfo: {
                    entries: {},
                    sortedIds: [],
                },
                vMarketsInfo: {},
                vMarketIdsByMarket: {},
            };
            state.fetchItems.loading = true;
            state.fetchItems.error = null;
            state.cacheable = false;
        },
        fetchCommonDataSuccess(state, { payload }) {
            state.entries = {
                sports: (0, slices_1.toIdsMap)(payload.entries.sports.items),
                sportsIdsOrder: (0, slices_1.toIdsArray)(payload.entries.sports.items),
                sportIdsByGenericSportId: (0, utils_1.groupChildrenSportIdsByGenericSportId)(payload.entries.sports.items),
                outcomeCategories: (0, slices_1.toIdsMap)(payload.entries.outcomeCategories.items),
                markets: (0, slices_1.toIdsMap)(payload.entries.markets.items),
                currencies: (0, slices_1.toIdsMap)(payload.entries.currencies.items),
                outcomeTypes: (0, flow_1.default)((0, mapValues_1.default)('orderedOutcomeTypes'), (0, flatMap_1.default)(identity_1.default), (0, keyBy_1.default)('id'))(payload.entries.markets.items),
                mainOutcomeTypes: (0, utils_1.collectMainOutcomes)(payload.entries.markets.items),
                marketCategories: {
                    entries: (0, utils_1.computeMarketCategoriesEntries)((0, slices_1.toIdsMap)(payload.entries.marketCategories.items)),
                    sortedIds: (0, slices_1.toIdsArray)(payload.entries.marketCategories.items),
                },
                categoryMarketInfosMap: (0, utils_1.computeCategoryMarketInfosMap)(payload.entries.marketCategories.items),
                virtualCategories: {
                    entries: (0, utils_1.computeVirtualCategoriesEntries)((0, slices_1.toIdsMap)(payload.entries.virtualCategories.items)),
                    sortedIds: (0, slices_1.toIdsArray)(payload.entries.virtualCategories.items),
                },
                virtualMarketInfosMap: (0, utils_1.computeVirtualMarketInfosMap)(payload.entries.virtualCategories.items),
                marketGroups: {
                    entries: (0, slices_1.toIdsMap)(payload.entries.marketGroups.items),
                    sortedIds: (0, slices_1.toIdsArray)(payload.entries.marketGroups.items),
                },
                systemCurrencies: (0, utils_1.formatSystemCurrencies)(payload.entries.systemCurrencies.items),
                matchPhases: (0, slices_1.toIdsMap)(payload.entries.matchPhases.items),
                hotProbabilitiesGroups: (0, mapValues_2.default)((0, keyBy_2.default)(payload.entries.hotProbabilitiesGroups.items, 'id'), (item) => ({
                    ...item,
                    sports: (0, keyBy_2.default)(item.sports, 'sportId'),
                })),
                entityTags: (0, slices_1.toIdsMap)(payload.entries.entityTags.items),
                vCategoriesInfo: {
                    entries: {},
                    sortedIds: [],
                },
                vMarketsInfo: {},
                vMarketIdsByMarket: {},
            };
            state.fetchItems.loading = false;
            state.fetchItems.error = null;
            state.cacheable = payload.fromServer;
        },
        fetchCommonDataError(state, action) {
            state.fetchItems.loading = false;
            state.fetchItems.error = action.payload;
            state.cacheable = false;
        },
        setCommonData(state, action) {
            state.fetchItems = action.payload.data.fetchItems;
            state.entries = action.payload.data.entries;
            state.cacheable = false;
        },
        fetchCommonDataSuccessNew(state, { payload }) {
            state.fetchItems.loading = false;
            state.fetchItems.error = null;
            state.fetchItems.loaded = true;
            state.cacheable = payload.fromServer;
        },
        setCommonDataEntries(state, { payload }) {
            const { entries } = payload;
            if (entries.sports && entries.sports.items.length !== 0) {
                state.entries.sports = (0, slices_1.toIdsMap)(entries.sports.items);
                state.entries.sportsIdsOrder = (0, slices_1.toIdsArray)(entries.sports.items);
                state.entries.sportIdsByGenericSportId =
                    (0, utils_1.groupChildrenSportIdsByGenericSportId)(entries.sports.items);
            }
            if (entries.outcomeCategories &&
                entries.outcomeCategories.items.length !== 0) {
                state.entries.outcomeCategories = (0, slices_1.toIdsMap)(entries.outcomeCategories.items);
            }
            if (entries.markets && entries.markets.items.length !== 0) {
                state.entries.markets = (0, slices_1.toIdsMap)(entries.markets.items);
                state.entries.outcomeTypes = (0, flow_1.default)((0, mapValues_1.default)('orderedOutcomeTypes'), (0, flatMap_1.default)(identity_1.default), (0, keyBy_1.default)('id'))(entries.markets.items);
                state.entries.mainOutcomeTypes = (0, utils_1.collectMainOutcomes)(entries.markets.items);
            }
            if (entries.currencies && entries.currencies.items.length !== 0) {
                state.entries.currencies = (0, slices_1.toIdsMap)(entries.currencies.items);
            }
            if (entries.marketCategories &&
                entries.marketCategories.items.length !== 0) {
                state.entries.marketCategories = {
                    entries: (0, utils_1.computeMarketCategoriesEntries)((0, slices_1.toIdsMap)(entries.marketCategories.items)),
                    sortedIds: (0, slices_1.toIdsArray)(entries.marketCategories.items),
                };
                state.entries.categoryMarketInfosMap = (0, utils_1.computeCategoryMarketInfosMap)(entries.marketCategories.items);
            }
            if (entries.marketGroups && entries.marketGroups.items.length !== 0) {
                state.entries.marketGroups = {
                    entries: (0, slices_1.toIdsMap)(entries.marketGroups.items),
                    sortedIds: (0, slices_1.toIdsArray)(entries.marketGroups.items),
                };
            }
            if (entries.systemCurrencies &&
                entries.systemCurrencies.items.length !== 0) {
                state.entries.systemCurrencies = (0, utils_1.formatSystemCurrencies)(entries.systemCurrencies.items);
            }
            if (entries.matchPhases && entries.matchPhases.items.length !== 0) {
                state.entries.matchPhases = (0, slices_1.toIdsMap)(entries.matchPhases.items);
            }
            if (entries.hotProbabilitiesGroups &&
                entries.hotProbabilitiesGroups.items.length !== 0) {
                state.entries.hotProbabilitiesGroups = (0, mapValues_2.default)((0, keyBy_2.default)(entries.hotProbabilitiesGroups.items, 'id'), (item) => ({
                    ...item,
                    sports: (0, keyBy_2.default)(item.sports, 'sportId'),
                }));
            }
            if (entries.entityTags && entries.entityTags.items.length !== 0) {
                state.entries.entityTags = (0, slices_1.toIdsMap)(entries.entityTags.items);
            }
            if (entries.virtualCategories &&
                entries.virtualCategories.items.length !== 0) {
                state.entries.virtualCategories = {
                    entries: (0, utils_1.computeVirtualCategoriesEntries)((0, slices_1.toIdsMap)(entries.virtualCategories.items)),
                    sortedIds: (0, slices_1.toIdsArray)(entries.virtualCategories.items),
                };
                state.entries.virtualMarketInfosMap = (0, utils_1.computeVirtualMarketInfosMap)(entries.virtualCategories.items);
            }
        },
        setCommonDataEntriesV2(state, { payload }) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            const { entries } = payload;
            /* SPORTS */
            const sports = (_a = entries.sports) === null || _a === void 0 ? void 0 : _a.items;
            if (sports && sports.length !== 0) {
                const entries = (0, toStore_1.sportsToStore)(sports);
                state.entries.sports = entries.sports;
                state.entries.sportsIdsOrder = entries.sportsIdsOrder;
                state.entries.sportIdsByGenericSportId =
                    entries.sportIdsByGenericSportId;
            }
            /* OUTCOMES CATEGORIES */
            const outcomesCategories = (_b = entries.outcomeCategories) === null || _b === void 0 ? void 0 : _b.items;
            if (outcomesCategories && outcomesCategories.length !== 0) {
                const entries = (0, toStore_1.outcomeCategoriesToStore)(outcomesCategories);
                state.entries.outcomeCategories = entries.outcomeCategories;
            }
            /* MARKETS */
            const markets = (_c = entries.markets) === null || _c === void 0 ? void 0 : _c.items;
            if (markets && markets.length !== 0) {
                const entries = (0, toStore_1.marketsToStore)(markets);
                state.entries.markets = entries.markets;
                state.entries.outcomeTypes = entries.outcomeTypes;
                state.entries.mainOutcomeTypes = entries.mainOutcomeTypes;
            }
            /* CURRENCIES */
            const currencies = (_d = entries.currencies) === null || _d === void 0 ? void 0 : _d.items;
            if (currencies && currencies.length !== 0) {
                state.entries.currencies = (0, toStore_1.currenciesToStore)(currencies).currencies;
            }
            /* MARKET CATEGORIES */
            const marketCategories = (_e = entries.marketCategories) === null || _e === void 0 ? void 0 : _e.items;
            if (marketCategories && marketCategories.length !== 0) {
                const entries = (0, toStore_1.marketCategoriesToStore)(marketCategories);
                state.entries.marketCategories = entries.marketCategories;
                state.entries.categoryMarketInfosMap = entries.categoryMarketInfosMap;
            }
            /* MARKET GROUPS */
            const marketGroups = (_f = entries.marketGroups) === null || _f === void 0 ? void 0 : _f.items;
            if (marketGroups && marketGroups.length !== 0) {
                state.entries.marketGroups =
                    (0, toStore_1.marketGroupsToStore)(marketGroups).marketGroups;
            }
            /* SYSTEM CURRENCIES */
            const systemCurrencies = (_g = entries.systemCurrencies) === null || _g === void 0 ? void 0 : _g.items;
            if (systemCurrencies && systemCurrencies.length !== 0) {
                state.entries.systemCurrencies =
                    (0, toStore_1.systemCurrenciesToStore)(systemCurrencies).systemCurrencies;
            }
            /* MATCH PHASES */
            const matchPhases = (_h = entries.matchPhases) === null || _h === void 0 ? void 0 : _h.items;
            if (matchPhases && matchPhases.length !== 0) {
                state.entries.matchPhases = (0, toStore_1.matchPhasesToStore)(matchPhases).matchPhases;
            }
            /* HOT PROBABILITIES GROUPS */
            const hotProbabilitiesGroups = (_j = entries.hotProbabilitiesGroups) === null || _j === void 0 ? void 0 : _j.items;
            if (hotProbabilitiesGroups && hotProbabilitiesGroups.length !== 0) {
                state.entries.hotProbabilitiesGroups = (0, toStore_1.hotProbabilitiesGroupsToStore)(hotProbabilitiesGroups).hotProbabilitiesGroups;
            }
            /* ENTITY TAGS */
            const entityTags = (_k = entries.entityTags) === null || _k === void 0 ? void 0 : _k.items;
            if (entityTags && entityTags.length !== 0) {
                state.entries.entityTags = (0, toStore_1.entityTagsToStore)(entityTags).entityTags;
            }
            /* VIRTUAL CATEGORIES */
            const virtualCategories = (_l = entries.virtualCategories) === null || _l === void 0 ? void 0 : _l.items;
            if (virtualCategories) {
                const isNewStruct = (0, ConfigProvider_1.isFeatureFlagEnabled)(ConfigProvider_1.EFeatureFlags.NEW_OUTCOMES_STRUCT_ENABLED);
                if (isNewStruct) {
                    const entries = (0, toStore_1.virtualCategoriesToStoreV2)(virtualCategories);
                    state.entries.vCategoriesInfo = entries.vCategoriesInfo;
                    state.entries.vMarketsInfo = entries.vMarketsInfo;
                    state.entries.vMarketIdsByMarket = entries.vMarketIdsByMarket;
                }
                else {
                    const entries = (0, toStore_1.virtualCategoriesToStore)(virtualCategories);
                    state.entries.virtualCategories = entries.virtualCategories;
                    state.entries.virtualMarketInfosMap = entries.virtualMarketInfosMap;
                }
            }
        },
        refetchCommonData() { },
        fetchCommonDataV2(state, _action) {
            state.fetchItems.loading = true;
            state.fetchItems.error = null;
        },
    },
});
exports.commonDataProviderActions = commonDataProviderSlice.actions, exports.reducer = commonDataProviderSlice.reducer, exports.sliceKey = commonDataProviderSlice.name;
//# sourceMappingURL=slice.js.map